export default "__VITE_ASSET__gE7r$mDH__"